































import Vue, { PropType } from "vue"
import { NormalOption } from "~/clStores/profileSearchParameterOption"

export default Vue.extend({
  props: {
    value: {
      type: Number,
      default: null,
    },
    options: {
      type: Array as PropType<NormalOption[]>,
      required: true,
    },
  },
  methods: {
    isSelected(sinceLastAccessDays: number | null): boolean {
      return this.value === sinceLastAccessDays
    },
    handleInput(sinceLastAccessDays: number | null) {
      this.$emit("input", sinceLastAccessDays)
    },
  },
})
